import { render, staticRenderFns } from "./ReceiverLicenseChangeHistoryPage.vue?vue&type=template&id=550a386c&scoped=true&"
import script from "./ReceiverLicenseChangeHistoryPage.vue?vue&type=script&lang=js&"
export * from "./ReceiverLicenseChangeHistoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550a386c",
  null
  
)

export default component.exports